import {DateTime} from 'luxon'
export default {
    computed: {
        locale() {
            return ( window.navigator.languages && window.navigator.languages.length ? window.navigator.languages[0] : window.navigator.language ) || 'en-US';
        },
    },
    methods: {
        parseLuxon(date) {
            // this function consider user input so default is the format based on locale
            return DateTime.fromJSDate(date).isValid ? DateTime.fromJSDate(date) : DateTime.fromISO(date.replaceAll('/','-')).isValid ? DateTime.fromISO(date.replaceAll('/','-')) : DateTime.fromFormat(date.replaceAll('-','/'), this.format).isValid ? DateTime.fromFormat(date.replaceAll('-','/'), this.format) : null;
        },
        parseLuxonDefaultMonth(date) {
            // this function consider backend data (ISO - yyyy-mm-dd or mm/dd/yyyy)
            return DateTime.fromJSDate(date).isValid ? DateTime.fromJSDate(date) : DateTime.fromISO(date.replaceAll('/','-')).isValid ? DateTime.fromISO(date.replaceAll('/','-')) : DateTime.fromFormat(date.replaceAll('-','/'), 'MM/dd/yyyy').isValid ? DateTime.fromFormat(date.replaceAll('-','/'), 'MM/dd/yyyy') : null;
        },
        getDateFormat() {
            // this function is to know which date format broswer use before mounted.
            let format = DateTime.fromISO('2024-05-20').toLocaleString(DateTime.DATE_SHORT, {locale : this.locale});
            let firstValue = format.split('/')[0];
            if (this.locale === 'en-CA') return 'dd/MM/yyyy';
            if (parseInt(firstValue) > 1000) return 'yyyy/MM/dd';
            else if (parseInt(firstValue) > 10) return 'dd/MM/yyyy';
            else return 'MM/dd/yyyy';
        },
    },
  }
